var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { padding: "10px", color: "#d9d9d9" } }, [
        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OcrTip")))
      ]),
      _c("div", { staticClass: "result-form-se" }, [
        _c(
          "div",
          {
            style: {
              cursor: "pointer",
              width: _vm.showBookRecognitionResults ? "70%" : "50%"
            }
          },
          [
            _c(
              "div",
              { staticClass: "row", staticStyle: { position: "relative" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "item1",
                    staticStyle: {
                      "font-weight": "bold",
                      color: "white",
                      "background-color": "#3f3f3f"
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FieldName")))
                    ])
                  ]
                ),
                _vm.showBookRecognitionResults
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          left: "105px",
                          top: "6px",
                          padding: "2px",
                          "background-color": "white",
                          cursor: "pointer"
                        },
                        on: {
                          click: function($event) {
                            _vm.showBookRecognitionResults = false
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PackUp")))]
                    )
                  : _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          left: "105px",
                          top: "6px",
                          padding: "2px",
                          "background-color": "white",
                          cursor: "pointer"
                        },
                        on: {
                          click: function($event) {
                            _vm.showBookRecognitionResults = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExpandAll")))]
                    ),
                _vm.showBookRecognitionResults
                  ? _c(
                      "div",
                      {
                        staticClass: "item2",
                        staticStyle: {
                          "font-weight": "bold",
                          color: "white",
                          "background-color": "#3f3f3f"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_BookRecognitionResults")
                          )
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "item3",
                    staticStyle: {
                      "font-weight": "bold",
                      color: "white",
                      "background-color": "#abd08e"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_ConfirmedBusinessData"))
                    )
                  ]
                )
              ]
            ),
            _vm.currentOcrRecognitionFields &&
            _vm.currentOcrRecognitionFields.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.currentOcrRecognitionFields, function(item) {
                    return _c("div", { key: item.code }, [
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMER_ID.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ConsignationCompany")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-company-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.customerId &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  "method-params": {
                                    customer: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "default-value": _vm.job.customerId || "",
                                  placeholder:
                                    !_vm.job.customerId &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  change: function(p) {
                                    _vm.customerIdChangeHandlerOcr(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_WAREHOUSE_NO.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.WarehouseNo"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.warehouseNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "warehouseNo", $$v)
                                  },
                                  expression: "job.warehouseNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_SHIPPER.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.Shipper")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: { rows: 6, type: "textarea" },
                                model: {
                                  value: _vm.job.shipper,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipper", $$v)
                                  },
                                  expression: "job.shipper"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_CONSIGNEE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.Consignee")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: { rows: 6, type: "textarea" },
                                model: {
                                  value: _vm.job.consignee,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "consignee", $$v)
                                  },
                                  expression: "job.consignee"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_NOTIFY.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.Notify")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: { rows: 6, type: "textarea" },
                                model: {
                                  value: _vm.job.notify,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "notify", $$v)
                                  },
                                  expression: "job.notify"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_CARRIER.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ShippingCompany"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-company-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.carrierId &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  "method-params": {
                                    companyLob: "seaExport",
                                    seaCmp: true,
                                    active: true
                                  },
                                  "default-value": _vm.job.carrierId || "",
                                  placeholder:
                                    !_vm.job.carrierId &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  change: function(p) {
                                    _vm.pm.carrierChangeHandler(
                                      _vm.job.dischargingPortCode,
                                      p.value
                                    )
                                    _vm.initIfAutoBookingHandle(_vm.job)
                                    _vm.cargoEnglishNameCheckSensitiveWord(
                                      _vm.job
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_VESSEL.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.vessel")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "vessel",
                                  "select-type":
                                    _vm.selectTypeNames.static_data_Vessel,
                                  cache: false,
                                  filterable: "",
                                  "allow-create": true,
                                  "default-value": _vm.job.vessel,
                                  "static-options": _vm.vesselList
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.onVesselSelectionChange(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_VOYAGE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.voyage")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "item3",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "item3",
                                    style: {
                                      borderColor: _vm.getValueBorderColor(item)
                                    },
                                    model: {
                                      value: _vm.job.voyageFlight,
                                      callback: function($$v) {
                                        _vm.$set(_vm.job, "voyageFlight", $$v)
                                      },
                                      expression: "job.voyageFlight"
                                    }
                                  }),
                                  _vm.showChooseShippingSchedulesBtn
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "background-color": "#169bd5"
                                          },
                                          attrs: { type: "primary" },
                                          on: { click: _vm.btnVayageShowHandle }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_ChooseShippingSchedules"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_ETD.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("queryJob.dateOfDeparture"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-date-picker", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  value: _vm.job.etd,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { input: _vm.etdChange }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_PAYMENT_TERM.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "block",
                                    width: "100%"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item1",
                                          style: {
                                            color: _vm.getFieldColor(item)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.FreightTerm")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm.showBookRecognitionResults
                                        ? _c("div", { staticClass: "item2" }, [
                                            _vm._v(
                                              _vm._s(_vm.resultJson[item.code])
                                            )
                                          ])
                                        : _vm._e(),
                                      _c("cargo-advance-select", {
                                        staticClass: "item3",
                                        class:
                                          !_vm.job.paymentTermMBL &&
                                          _vm.resultJson[item.code] &&
                                          !_vm.resultJson[
                                            item.code + "_notShowPlaceholder"
                                          ]
                                            ? "color-red"
                                            : "",
                                        style: {
                                          borderColor: _vm.getValueBorderColor(
                                            item
                                          )
                                        },
                                        attrs: {
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_PaymentTerm,
                                          filterable: "",
                                          clearable: "",
                                          "default-value":
                                            _vm.job.paymentTermMBL,
                                          placeholder:
                                            !_vm.job.paymentTermMBL &&
                                            _vm.resultJson[item.code] &&
                                            !_vm.resultJson[
                                              item.code + "_notShowPlaceholder"
                                            ]
                                              ? _vm.resultJson[item.code]
                                              : ""
                                        },
                                        on: {
                                          clear: function($event) {
                                            return _vm.clear(item)
                                          },
                                          parentCallBack: function(p) {
                                            _vm.paymentTermMBL = p.value
                                            _vm.job.paymentTermMBL = p.value
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.paymentTermMBL === "3P",
                                          expression: "paymentTermMBL === '3P'"
                                        }
                                      ],
                                      staticStyle: { display: "flex" }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "item1",
                                          style: {
                                            color: _vm.getFieldColor(item)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("CargoMsg.Cargo_Payment1")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm.showBookRecognitionResults
                                        ? _c("el-input", {
                                            staticClass: "item2",
                                            attrs: {
                                              value: "",
                                              disabled: "",
                                              rows: 6,
                                              type: "textarea"
                                            }
                                          })
                                        : _vm._e(),
                                      _c("el-input", {
                                        staticClass: "item3",
                                        style: {
                                          borderColor: _vm.getValueBorderColor(
                                            item
                                          )
                                        },
                                        attrs: { rows: 6, type: "textarea" },
                                        model: {
                                          value: _vm.job.paymentData,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.job,
                                              "paymentData",
                                              $$v
                                            )
                                          },
                                          expression: "job.paymentData"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CONTAINER_INFOS.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CartonQuantity")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "item3",
                                  staticStyle: { "overflow-y": "auto" },
                                  style: {
                                    borderColor: _vm.getValueBorderColor(item)
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            "max-height": "200px"
                                          }
                                        },
                                        _vm._l(_vm.job.seaEQ, function(
                                          item,
                                          index
                                        ) {
                                          return _c("div", { key: index }, [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: { display: "flex" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "49%"
                                                    }
                                                  },
                                                  [
                                                    _c("el-input-number", {
                                                      staticClass: "item3-1",
                                                      staticStyle: {
                                                        width: "40px"
                                                      },
                                                      attrs: {
                                                        controls: false,
                                                        no: "eqQuantity"
                                                      },
                                                      model: {
                                                        value: item.eqQuantity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "eqQuantity",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.eqQuantity"
                                                      }
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "5px"
                                                        }
                                                      },
                                                      [_vm._v("X")]
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex"
                                                    }
                                                  },
                                                  [
                                                    _c("cargo-advance-select", {
                                                      staticClass: "item3-1",
                                                      staticStyle: {
                                                        width: "60px",
                                                        "margin-left": "5px"
                                                      },
                                                      attrs: {
                                                        no: "eqSize",
                                                        "select-type":
                                                          _vm.selectTypeNames
                                                            .local_cache_EQSize,
                                                        fields: ["code"],
                                                        filterable: "",
                                                        placeholder: " ",
                                                        "show-copy": false,
                                                        "default-value":
                                                          item.eqSize,
                                                        "tag-name": "code"
                                                      },
                                                      on: {
                                                        parentCallBack: function(
                                                          p
                                                        ) {
                                                          _vm.changeSizeCallBack(
                                                            item,
                                                            p
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _c("cargo-advance-select", {
                                                      staticClass: "item3-1",
                                                      staticStyle: {
                                                        width: "60px",
                                                        "margin-left": "5px"
                                                      },
                                                      attrs: {
                                                        no: "eqType",
                                                        "select-type":
                                                          _vm.selectTypeNames
                                                            .basic_data_EQType,
                                                        fields: ["code"],
                                                        filterable: "",
                                                        placeholder: " ",
                                                        "show-copy": false,
                                                        "default-value":
                                                          item.eqType,
                                                        "tag-name": "code"
                                                      },
                                                      on: {
                                                        parentCallBack: function(
                                                          p
                                                        ) {
                                                          _vm.changeTypeCallBack(
                                                            item,
                                                            p
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#1398f1",
                                                      "margin-left": "5px",
                                                      "font-size": "25px",
                                                      cursor: "pointer"
                                                    },
                                                    on: { click: _vm.addSeaEQ }
                                                  },
                                                  [_vm._v("+")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      color: "#1398f1",
                                                      "margin-left": "5px",
                                                      "font-size": "25px",
                                                      cursor: "pointer"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.deleteSeaEQ(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("-")]
                                                )
                                              ]
                                            )
                                          ])
                                        }),
                                        0
                                      ),
                                      !_vm.job.seaEQ ||
                                      _vm.job.seaEQ.length === 0
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                color: "#1398f1",
                                                "margin-top": "10px",
                                                "margin-left": "5px",
                                                cursor: "pointer"
                                              },
                                              on: { click: _vm.addSeaEQ }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("CargoMsg.Cargo_Add")
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_INCO_TERM.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("queryJob.IncoTerm")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.incoTerm &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "incoTerm",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_IncoTerm,
                                  filterable: "",
                                  clearable: "",
                                  "default-value": _vm.job.incoTerm,
                                  placeholder:
                                    !_vm.job.incoTerm &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  parentCallBack: function(p) {
                                    _vm.job.incoTerm = p.value
                                    _vm.customerRefNoCheckSensitiveWord(_vm.job)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMER_CONTACT.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Payment.contactPerson"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.customerContact,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "customerContact", $$v)
                                  },
                                  expression: "job.customerContact"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_MEASUREMENTS.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.CargoSize")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.measurements,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "measurements", $$v)
                                  },
                                  expression: "job.measurements"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_LOADING_PORT_CODE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Payment.portOfLoading"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.loadingPortCode &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "englishName",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.job.loadingPortCode,
                                  "tag-name": "englishName",
                                  placeholder:
                                    !_vm.job.loadingPortCode &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  parentCallBack: function(p) {
                                    _vm.pm.loadingPortCodeChange(p)
                                    _vm.pm.setPlannerChange()
                                    _vm.cargoEnglishNameCheckSensitiveWord(
                                      _vm.job
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_TRANSFER_PORT_CODE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Payment.portOfTransfer"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.transferPortCode &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "transferPortCode",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.job.transferPortCode,
                                  placeholder:
                                    !_vm.job.transferPortCode &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  parentCallBack: function(p) {
                                    _vm.job.transferPortCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_DISCHARGING_PORT_CODE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("queryJob.dischargingPortCode")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.dischargingPortCode &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "dischargingPortCode",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.job.dischargingPortCode,
                                  placeholder:
                                    !_vm.job.dischargingPortCode &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  parentCallBack: function(p) {
                                    _vm.pm.dischargingPortCodeChange(
                                      p.value,
                                      _vm.job.carrierId
                                    )
                                    _vm.cargoEnglishNameCheckSensitiveWord(
                                      _vm.job
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_DESTINATION_PORT_CODE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("queryJob.placeOfDelivery"))
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.destinationPortCode &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "destinationPortCode",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  filterable: "",
                                  "default-value": _vm.job.destinationPortCode,
                                  placeholder:
                                    !_vm.job.destinationPortCode &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  parentCallBack: function(p) {
                                    _vm.job.destinationPortCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_QUANTITY.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-input-number", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item),
                                  textAlign: "left"
                                },
                                attrs: {
                                  controls: false,
                                  no: "quantityContract"
                                },
                                model: {
                                  value: _vm.job.quantityContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "quantityContract", $$v)
                                  },
                                  expression: "job.quantityContract"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_PACKING.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Package")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-packing-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.packing &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "packing",
                                  "default-value": _vm.job.packing,
                                  placeholder:
                                    !_vm.job.packing &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  change: function(p) {
                                    _vm.job.packing = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_CUBAGE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-input-number", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item),
                                  textAlign: "left"
                                },
                                attrs: {
                                  precision: 3,
                                  controls: false,
                                  no: "cubageContract"
                                },
                                model: {
                                  value: _vm.job.cubageContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cubageContract", $$v)
                                  },
                                  expression: "job.cubageContract"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_GROSS_WEIGHT.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Weight")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-input-number", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item),
                                  textAlign: "left"
                                },
                                attrs: {
                                  precision: 3,
                                  controls: false,
                                  no: "weightContract"
                                },
                                model: {
                                  value: _vm.job.weightContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "weightContract", $$v)
                                  },
                                  expression: "job.weightContract"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_MARK.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Marks")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  no: "mark"
                                },
                                model: {
                                  value: _vm.job.mark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "mark", $$v)
                                  },
                                  expression: "job.mark"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_GOOD_NAME.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Pricing.Goods")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    attrs: {
                                      disabled: "",
                                      rows: 6,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                class:
                                  _vm.job.ifContainSensitiveWord === true
                                    ? "color-yellow"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  rows: 6,
                                  type: "textarea",
                                  no: "cargoEnglishName"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.cargoEnglishNameCheckSensitiveWord(
                                      _vm.job
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cargoEnglishName", $$v)
                                  },
                                  expression: "job.cargoEnglishName"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_REMARKS.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.remarks")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("el-input", {
                                    staticClass: "item2",
                                    attrs: {
                                      disabled: "",
                                      rows: 5,
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.resultJson[item.code],
                                      callback: function($$v) {
                                        _vm.$set(_vm.resultJson, item.code, $$v)
                                      },
                                      expression: "resultJson[item.code]"
                                    }
                                  })
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: { rows: 5, type: "textarea" },
                                model: {
                                  value: _vm.job.remarks,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "remarks", $$v)
                                  },
                                  expression: "job.remarks"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_ORDER_TYPE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.BLForm")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c(
                                "el-select",
                                {
                                  staticClass: "item3",
                                  class:
                                    !_vm.job.orderType &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? "color-red"
                                      : "",
                                  style: {
                                    borderColor: _vm.getValueBorderColor(item)
                                  },
                                  attrs: {
                                    placeholder:
                                      !_vm.job.orderType &&
                                      _vm.resultJson[item.code] &&
                                      !_vm.resultJson[
                                        item.code + "_notShowPlaceholder"
                                      ]
                                        ? _vm.resultJson[item.code]
                                        : "",
                                    no: "orderType",
                                    clearable: ""
                                  },
                                  on: {
                                    clear: function($event) {
                                      return _vm.clear(item)
                                    }
                                  },
                                  model: {
                                    value: _vm.job.orderType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "orderType", $$v)
                                    },
                                    expression: "job.orderType"
                                  }
                                },
                                _vm._l(_vm.blModeList, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.name,
                                      value: item.serialNumber
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CONTAINER_LOAD_TYPE.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.LCL")))]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c(
                                "el-select",
                                {
                                  staticClass: "item3",
                                  style: {
                                    borderColor: _vm.getValueBorderColor(item)
                                  },
                                  attrs: { no: "containerLoadType" },
                                  on: {
                                    change: function($event) {
                                      return _vm.initIfAutoBookingHandle(
                                        _vm.job
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.job.containerLoadType,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.job,
                                        "containerLoadType",
                                        $$v
                                      )
                                    },
                                    expression: "job.containerLoadType"
                                  }
                                },
                                _vm._l(_vm.containerLoadTypes, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.isZh
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_FREIGHT_TERM.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.TransportationClause")
                                    )
                                  )
                                ]
                              ),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("cargo-advance-select", {
                                staticClass: "item3",
                                class:
                                  !_vm.job.freightTerm &&
                                  _vm.resultJson[item.code] &&
                                  !_vm.resultJson[
                                    item.code + "_notShowPlaceholder"
                                  ]
                                    ? "color-red"
                                    : "",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "freightTerm",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_ShippingTerm,
                                  filterable: "",
                                  clearable: "",
                                  "default-value": _vm.job.freightTerm,
                                  placeholder:
                                    !_vm.job.freightTerm &&
                                    _vm.resultJson[item.code] &&
                                    !_vm.resultJson[
                                      item.code + "_notShowPlaceholder"
                                    ]
                                      ? _vm.resultJson[item.code]
                                      : ""
                                },
                                on: {
                                  clear: function($event) {
                                    return _vm.clear(item)
                                  },
                                  parentCallBack: function(p) {
                                    _vm.job.freightTerm = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMER_REF_NO.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "item1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_BusinessReferenceNo")
                                  )
                                )
                              ]),
                              _vm.showBookRecognitionResults
                                ? _c("div", { staticClass: "item2" }, [
                                    _vm._v(_vm._s(_vm.resultJson[item.code]))
                                  ])
                                : _vm._e(),
                              _c("el-input", {
                                staticClass: "item3",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.customerRefNoCheckSensitiveWord(
                                      _vm.job
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.customerRefNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "customerRefNo", $$v)
                                  },
                                  expression: "job.customerRefNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                )
              : _vm._e()
          ]
        ),
        _c(
          "div",
          {
            style: {
              marginLeft: "5px",
              width: _vm.showBookRecognitionResults ? "30%" : "50%"
            }
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  "background-color": "white",
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "left",
                  "min-height": "24px",
                  "padding-left": "12px",
                  "border-left": "9px solid #f2f2f2",
                  "margin-top": "2px",
                  "margin-bottom": "2px"
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_OtherData")) + " ")]
            ),
            _vm.currentOcrOtherFields && _vm.currentOcrOtherFields.length > 0
              ? _c(
                  "div",
                  _vm._l(_vm.currentOcrOtherFields, function(item) {
                    return _c("div", { key: item.code }, [
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CARGOSOURCE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_SolicitationType")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticClass: "item4",
                                  style: {
                                    borderColor: _vm.getValueBorderColor(item)
                                  },
                                  attrs: {
                                    no: "cargoSource",
                                    placeholder: _vm.$t(
                                      "SeaExport.PleaseSelect"
                                    ),
                                    size: "mini"
                                  },
                                  model: {
                                    value: _vm.job.cargoSource,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "cargoSource", $$v)
                                    },
                                    expression: "job.cargoSource"
                                  }
                                },
                                _vm._l(
                                  _vm.SystemConstants.CARGO_SOURCES,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: _vm.isZh
                                          ? item.chineseName
                                          : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_ARRIVEDATE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.CargosExpectedArrivalDate"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "arriveDate",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss"
                                },
                                model: {
                                  value: _vm.job.arriveDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "arriveDate", $$v)
                                  },
                                  expression: "job.arriveDate"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMCUTOFF.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CYCutOffDate")
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "customCutoff",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss"
                                },
                                model: {
                                  value: _vm.job.customCutoff,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "customCutoff", $$v)
                                  },
                                  expression: "job.customCutoff"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMERCUTOFF.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.CustomerCyCutOffDate")
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "customerCutoff",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss"
                                },
                                model: {
                                  value: _vm.job.customerCutoff,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "customerCutoff", $$v)
                                  },
                                  expression: "job.customerCutoff"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMERSHUTOUT.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.CustomerShutOutDate")
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "customerShutout",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss"
                                },
                                model: {
                                  value: _vm.job.customerShutout,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "customerShutout", $$v)
                                  },
                                  expression: "job.customerShutout"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMERFILECUTOFF.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.CustomerClosingTime")
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "customerFileCutoff",
                                  type: "datetime",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm:ss"
                                },
                                model: {
                                  value: _vm.job.customerFileCutoff,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "customerFileCutoff", $$v)
                                  },
                                  expression: "job.customerFileCutoff"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_CSR.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CustomerService")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-user-select", {
                                ref: "csr",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "csr",
                                  "method-params": {
                                    officeId:
                                      _vm.job.salesOffice === 1
                                        ? _vm.job.opOffice
                                        : _vm.job.salesOffice,
                                    category: "role",
                                    shape: "csr"
                                  },
                                  "default-value": _vm.job.csr || "",
                                  "merge-load": true,
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.csr
                                      : []
                                    : []
                                },
                                on: {
                                  change: function(p) {
                                    _vm.csrChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_DC.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Documents"))
                                  )
                                ]
                              ),
                              _c("cargo-user-select", {
                                ref: "dc",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "dc",
                                  "method-params": {
                                    officeId: _vm.job.opOffice,
                                    category: "role",
                                    shape: "doc"
                                  },
                                  "default-value": _vm.job.dc || "",
                                  "merge-load": true,
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.doc
                                      : []
                                    : []
                                },
                                on: {
                                  change: function(p) {
                                    _vm.dcChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_SC_NO.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.ContractNo")))]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.scNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "scNo", $$v)
                                  },
                                  expression: "job.scNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_INSIDEQUANTITY.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_InsideQuantity")
                                    )
                                  )
                                ]
                              ),
                              _c("auto-number-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "insideQuantity",
                                  precision: 0,
                                  min: 0
                                },
                                on: {
                                  valCallBack: function(val) {
                                    _vm.job.insideQuantity = val
                                  }
                                },
                                model: {
                                  value: _vm.job.insideQuantity,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "insideQuantity", $$v)
                                  },
                                  expression: "job.insideQuantity"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_INSIDEPACKING.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_InsidePacking")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-packing-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "insidePacking",
                                  "default-value": _vm.job.insidePacking
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.insidePacking = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CHARGEWEIGHT.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ChargedWeightRT"))
                                  )
                                ]
                              ),
                              _c("auto-number-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "chargeWeight",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  valCallBack: function(val) {
                                    _vm.job.chargeWeight = val
                                  }
                                },
                                model: {
                                  value: _vm.job.chargeWeight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "chargeWeight", $$v)
                                  },
                                  expression: "job.chargeWeight"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center"
                                  }
                                },
                                [_vm._v("M/T")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CARGOCHINESENAME.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_ChineseCargoName")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "cargoChineseName",
                                  type: "textarea",
                                  autosize: { maxRows: 5, minRows: 2 }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t(
                                        "SeaExport.ChineseDescriptionOfGoods"
                                      ),
                                      _vm.job.cargoChineseName,
                                      function(val) {
                                        _vm.job.cargoChineseName = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.cargoChineseName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cargoChineseName", $$v)
                                  },
                                  expression: "job.cargoChineseName"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_USERDEFINEDFIELD1.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CustomizedField1")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "userDefinedField1",
                                  type: "textarea",
                                  autosize: { maxRows: 5, minRows: 2 }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.UserDefinedField1"),
                                      _vm.job.userDefinedField1,
                                      function(val) {
                                        _vm.job.userDefinedField1 = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.userDefinedField1,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "userDefinedField1", $$v)
                                  },
                                  expression: "job.userDefinedField1"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_USERDEFINEDFIELD2.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CustomizedField2")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "userDefinedField2",
                                  type: "textarea",
                                  autosize: { maxRows: 5, minRows: 2 }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.UserDefinedField2"),
                                      _vm.job.userDefinedField2,
                                      function(val) {
                                        _vm.job.userDefinedField2 = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.userDefinedField2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "userDefinedField2", $$v)
                                  },
                                  expression: "job.userDefinedField2"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_USERDEFINEDFIELD3.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CustomizedField3")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "userDefinedField3",
                                  type: "textarea",
                                  autosize: { maxRows: 5, minRows: 2 }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.UserDefinedField3"),
                                      _vm.job.userDefinedField3,
                                      function(val) {
                                        _vm.job.userDefinedField3 = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.userDefinedField3,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "userDefinedField3", $$v)
                                  },
                                  expression: "job.userDefinedField3"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_USERDEFINEDFIELD4.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CustomizedField4")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "userDefinedField4",
                                  type: "textarea",
                                  autosize: { maxRows: 5, minRows: 2 }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.UserDefinedField4"),
                                      _vm.job.userDefinedField4,
                                      function(val) {
                                        _vm.job.userDefinedField4 = val
                                      }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job.userDefinedField4,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "userDefinedField4", $$v)
                                  },
                                  expression: "job.userDefinedField4"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_SALES.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                              ),
                              _c("cargo-user-select", {
                                ref: "sales",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "sales",
                                  "method-params": {
                                    officeId: _vm.salesOfficeCheck
                                      ? _vm.$store.getters.currentOfficeId
                                      : "",
                                    category: "role",
                                    shape: "sales"
                                  },
                                  "default-value": _vm.job.sales || "",
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .salesList &&
                                      _vm.jobViewInfoMap.get(_vm.job.index)
                                        .salesList.length > 0
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .salesList
                                      : []
                                    : [],
                                  "merge-load": true
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.sales = p.value
                                    _vm.salesChangeHandler(p, _vm.job)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_SALES_OFFICE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.SalesCompany"))
                                  )
                                ]
                              ),
                              _c("cargo-office-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "salesOffice",
                                  "office-id": Number(_vm.job.salesOffice)
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.salesOffice = p.value || 0
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_SALES_DEPARTMENT.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.SalesDepartment"))
                                  )
                                ]
                              ),
                              _c("cargo-department-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "salesDepartment",
                                  "sales-id": Number(_vm.job.sales),
                                  "office-id": _vm.job.salesOffice,
                                  enables: true,
                                  "department-id": Number(
                                    _vm.job.salesDepartment
                                  )
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.salesDepartment = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_OP.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                              ),
                              _c("cargo-user-select", {
                                ref: "op",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "op",
                                  "method-params": {
                                    officeId: _vm.job.opOffice,
                                    category: "role",
                                    shape: "op"
                                  },
                                  "default-value": _vm.job.op || "",
                                  "merge-load": true,
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.op
                                      : []
                                    : []
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.op = p.value
                                    _vm.txtOPChangeHandler(p, _vm.job)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_OP_OFFICE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.OperationCompany"))
                                  )
                                ]
                              ),
                              _c("cargo-office-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "opOffice",
                                  disabled: true,
                                  "office-id": Number(_vm.job.opOffice)
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_OP_DEPARTMENT.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.OperationDepartment")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-department-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "opDepartment",
                                  "office-id": Number(_vm.job.opOffice),
                                  enables: true,
                                  "department-id": Number(_vm.job.opDepartment)
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.opDepartment = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CARGO_TYPE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.CargoType")))]
                              ),
                              _c("cargo-advance-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "cargoType",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CargoType,
                                  "method-params": { sea: true },
                                  filterable: "",
                                  clearable: "",
                                  "default-value": _vm.job.cargoType
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.cargoType = p.value
                                    _vm.cargoTypeHandle()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_BOOKING_AGENT.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BookingAgent"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "bookingAgent",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  filterable: "",
                                  "method-params": {
                                    bookingAgent: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "default-value": _vm.job.bookingAgent || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.bookingAgent = p.value
                                    _vm.initIfAutoBookingHandle(_vm.job)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_VESSEL_CODE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BookingShipCallSign")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.vesselCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "vesselCode", $$v)
                                  },
                                  expression: "job.vesselCode"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_IF_AUTO_BOOKING.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_IfAutoBooking")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  staticClass: "item4",
                                  style: {
                                    borderColor: _vm.getValueBorderColor(item)
                                  },
                                  attrs: {
                                    disabled: _vm.job.ifAutoBookingDisabled
                                  },
                                  model: {
                                    value: _vm.job.ifAutoBooking,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "ifAutoBooking", $$v)
                                    },
                                    expression: "job.ifAutoBooking"
                                  }
                                },
                                _vm._l(_vm.IF_AUTO_BOOKING, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.$getLangColumn(item),
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_NOVCC.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s("NOVCC"))]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: { no: "novcc" },
                                model: {
                                  value: _vm.job.novcc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "novcc", $$v)
                                  },
                                  expression: "job.novcc"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_TLI_NO.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s("TLI NO"))]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: { no: "tliNo" },
                                model: {
                                  value: _vm.job.tliNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "tliNo", $$v)
                                  },
                                  expression: "job.tliNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CARGO_AMOUNT.code
                        ? _c(
                            "div",
                            {
                              staticClass: "row",
                              on: {
                                click: function($event) {
                                  return _vm.handleFocus(item.code)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_CargoAmount"))
                                  )
                                ]
                              ),
                              _c("el-input-number", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item),
                                  textAlign: "left"
                                },
                                attrs: { controls: false, no: "amount" },
                                model: {
                                  value: _vm.job.amount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "amount", $$v)
                                  },
                                  expression: "job.amount"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CARGO_CURRENCY.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CargoCurrency")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "currency",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Currency,
                                  filterable: "",
                                  "default-value": _vm.job.currency || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.currency = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CUSTOMER_RESERVE_VOYAGE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_CustomerReserveVoyage"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.customerReserveVoyage,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.job,
                                      "customerReserveVoyage",
                                      $$v
                                    )
                                  },
                                  expression: "job.customerReserveVoyage"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OCR_FIELD_PAGE_NUM.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_GenerateNumberOfBusiness"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("auto-number-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "chargeWeight",
                                  min: 1,
                                  "enforce-min": true
                                },
                                on: {
                                  change: function(p) {
                                    return _vm.callCopyHandler(p)
                                  }
                                },
                                model: {
                                  value: _vm.job.copyNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "copyNumber", $$v)
                                  },
                                  expression: "job.copyNumber"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.USER_DEFINED_ROLE_ID_1.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-user-select", {
                                ref: "userDefinedRoleId1",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "userDefinedRoleId1",
                                  "method-params": {
                                    officeId:
                                      _vm.$store.getters.currentOfficeId,
                                    category: "role",
                                    shape: "userDefinedRole1"
                                  },
                                  "default-value":
                                    _vm.job.userDefinedRoleId1 || "",
                                  "merge-load": true,
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.userDefinedRole1
                                      : []
                                    : []
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.userDefinedRoleId1Handler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.USER_DEFINED_ROLE_ID_2.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-user-select", {
                                ref: "userDefinedRoleId2",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "userDefinedRoleId2",
                                  "method-params": {
                                    officeId:
                                      _vm.$store.getters.currentOfficeId,
                                    category: "role",
                                    shape: "userDefinedRole2"
                                  },
                                  "default-value":
                                    _vm.job.userDefinedRoleId2 || "",
                                  "merge-load": true,
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.userDefinedRole2
                                      : []
                                    : []
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.userDefinedRoleId2Handler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.OVERSEA_OP.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.OverseaCustomerService")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-user-select", {
                                ref: "overseaOp",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "overseaOp",
                                  "default-value": _vm.job.overseaOp || "",
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.overseaOp
                                      : []
                                    : _vm.overseaAgentUsersList,
                                  "merge-load": true
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.overseaOp = p.value
                                    _vm.pm.overseaOpChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.PLANNER.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.AirlinePerson2"))
                                  )
                                ]
                              ),
                              _c("cargo-user-select", {
                                ref: "planner",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "planner",
                                  "method-params": {
                                    officeId: _vm.job.opOffice,
                                    category: "role",
                                    shape: "seaLine"
                                  },
                                  "default-value": _vm.job.planner || "",
                                  "merge-load": true,
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.seaLine
                                      : []
                                    : []
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.planner = p.value
                                    _vm.pm.txtPlannerChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.DESTINATION_AGENT.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("queryJob.destinationAgent"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "destinationAgent",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "method-params": {
                                    overseaAgent: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "default-value":
                                    _vm.job.destinationAgent || "",
                                  filterable: "",
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "tag-name": "englishName"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.txtDestinationAgentChangeHandler(p)
                                  }
                                }
                              }),
                              _vm.overseaAgentDataProviderChange
                                ? _c("cargo-advance-select", {
                                    staticClass: "item4",
                                    style: {
                                      borderColor: _vm.getValueBorderColor(item)
                                    },
                                    attrs: {
                                      no: "destinationAgent2",
                                      "select-type":
                                        _vm.selectTypeNames.basic_data_Company,
                                      cache: false,
                                      "default-value":
                                        _vm.job.destinationAgent || "",
                                      filterable: "",
                                      "check-credit": true,
                                      headers: [_vm.$t("Partners.englishName")],
                                      fields: ["englishName"],
                                      "tag-name": "englishName",
                                      "static-options":
                                        _vm.pm.destinationAgentArray
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.txtDestinationAgentChangeHandler(
                                          p
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.EXCHANGE_AGENT.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BillExchangeAgent")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-company-select", {
                                ref: "exChangeAgent",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "exChangeAgent",
                                  "method-params": {
                                    bookingAgent: true,
                                    active: true
                                  },
                                  "default-value": _vm.job.exChangeAgent || ""
                                },
                                on: { change: _vm.onExChangeAgentChange }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.CARRIER_AGENT_ID.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CarrierAgent"))
                                  )
                                ]
                              ),
                              _c("cargo-company-select", {
                                ref: "carrierAgentId",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "carrierAgentId",
                                  "method-params": {
                                    seaCmpAgent: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "default-value": _vm.job.carrierAgentId || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.job.carrierAgentId = p.value
                                    _vm.initIfAutoBookingHandle(_vm.job)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.SUPPLIER_ID.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.WarehouseSupplier")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-company-select", {
                                ref: "warehouseCmp",
                                refInFor: true,
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "warehouseCmp",
                                  "method-params": {
                                    warehouse: true,
                                    active: true
                                  },
                                  "default-value": _vm.job.warehouseCmp || "",
                                  placeholder: _vm.$t(
                                    "SeaExport.PleaseSelectWarehouse"
                                  )
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.warehouseCmpChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.WAREHOUSE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.WareHouseName"))
                                  )
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  ref: "warehouseName",
                                  refInFor: true,
                                  staticClass: "item4",
                                  style: {
                                    borderColor: _vm.getValueBorderColor(item)
                                  },
                                  attrs: {
                                    no: "warehouseName",
                                    disabled: !_vm.job.warehouseCmp,
                                    "allow-create": true,
                                    filterable: "",
                                    clearable: true
                                  },
                                  on: {
                                    change: _vm.warehouseNameChangeHandler
                                  },
                                  model: {
                                    value: _vm.job.warehouseName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.job, "warehouseName", $$v)
                                    },
                                    expression: "job.warehouseName"
                                  }
                                },
                                _vm._l(_vm.warehouseNameList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.warehouseName,
                                      value: item.warehouseName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.CUSTOMS_BROKER.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CustomsBroker"))
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  no: "customsBroker",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "data-filter-function":
                                    _vm.customsBrokerFilter,
                                  filterable: "",
                                  "default-value": _vm.job.customsBroker || "",
                                  placeholder: _vm.$t(
                                    "CargoMsg.Cargo_keyWordsTip"
                                  ),
                                  "method-params": {
                                    customsBroker: true,
                                    companyLob: "seaExport",
                                    active: true
                                  }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.pm.customsBrokerChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.SITE_OP.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.FieldOperation"))
                                  )
                                ]
                              ),
                              _c("cargo-user-select", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                attrs: {
                                  "method-params": {
                                    officeId: _vm.job.opOffice,
                                    category: "role",
                                    shape: "siteOp"
                                  },
                                  "default-value": _vm.job.siteOP || "",
                                  "static-options": _vm.jobViewInfoMap.get(
                                    _vm.job.index
                                  )
                                    ? _vm.jobViewInfoMap.get(_vm.job.index)
                                        .userPortRoleData
                                      ? _vm.jobViewInfoMap.get(_vm.job.index)
                                          .userPortRoleData.siteOp
                                      : []
                                    : []
                                },
                                on: {
                                  change: function(p) {
                                    _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.CARRIER_VOYAGE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.CarrierVoyage"))
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.carrierVoyage,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "carrierVoyage", $$v)
                                  },
                                  expression: "job.carrierVoyage"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.MBL_NO.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s("MB/L No."))]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.mbl,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "mbl", $$v)
                                  },
                                  expression: "job.mbl"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.SO_NO.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [_vm._v(_vm._s("S/O No."))]
                              ),
                              _c("so-no-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.soNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "soNo", $$v)
                                  },
                                  expression: "job.soNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.ROUTE_CODE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_AirlineCode"))
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.routeCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "routeCode", $$v)
                                  },
                                  expression: "job.routeCode"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code === _vm.SystemConstants.BUSINESS_MARK.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_BusinessMark")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "businessMark",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .local_cache_SystemConstants$BUSINESS_MARK_LIST,
                                  "default-multiple-value":
                                    _vm.job.businessMark,
                                  multiple: true,
                                  "callback-method-type": "value"
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.job.businessMark = [].concat(p))
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_DISCHARGE_PORT_CODE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.PortCodeOfDischarge")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.portCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "portCode", $$v)
                                  },
                                  expression: "job.portCode"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_SHIPPER_CODE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ShipperCode"))
                                  )
                                ]
                              ),
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.shipperCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperCode", $$v)
                                  },
                                  expression: "job.shipperCode"
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                attrs: {
                                  no: "shipperId",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value": _vm.job.shipperId || "",
                                  "method-params": {
                                    shipper: true,
                                    active: true
                                  }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.shipperId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_CONSIGNEE_CODE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ConsigneeCode"))
                                  )
                                ]
                              ),
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.consigneeCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "consigneeCode", $$v)
                                  },
                                  expression: "job.consigneeCode"
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                attrs: {
                                  no: "consigneeId",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value": _vm.job.consigneeId || "",
                                  "method-params": {
                                    consignee: true,
                                    active: true
                                  }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.consigneeId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      item.code ===
                      _vm.SystemConstants.OCR_FIELD_NOTIFY_CODE.code
                        ? _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "item1",
                                  style: { color: _vm.getFieldColor(item) }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.NotifyPartyCode"))
                                  )
                                ]
                              ),
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "!synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                staticClass: "item4",
                                style: {
                                  borderColor: _vm.getValueBorderColor(item)
                                },
                                model: {
                                  value: _vm.job.notifyCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "notifyCode", $$v)
                                  },
                                  expression: "job.notifyCode"
                                }
                              }),
                              _c("cargo-advance-select", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.synchronousShipperCodeAndConsigneeCodeAndNotifyCode,
                                    expression:
                                      "synchronousShipperCodeAndConsigneeCodeAndNotifyCode"
                                  }
                                ],
                                attrs: {
                                  no: "notifyId",
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value": _vm.job.notifyId || "",
                                  "method-params": {
                                    notify: true,
                                    active: true
                                  }
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.job.notifyId = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm.shippingCompanySpecificCodeInvisible
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "div",
                      { staticClass: "item1", style: { color: "#8c8d8e" } },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.CarrierSpecificCode")))]
                    ),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "shippingCompanySpecificCode",
                        filterable: "",
                        "static-options": _vm.shippingCompanySpecificCodeList,
                        "allow-create": true,
                        "tag-name": "shippingCompanySpecificCode",
                        "tag-value": "shippingCompanySpecificCode",
                        "filter-tag-names": ["shippingCompanySpecificCode"]
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.shippingCompanySpecificCode = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.bookingTermShow
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "div",
                      { staticClass: "item1", style: { color: "#8c8d8e" } },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.ContractRateProperty")))]
                    ),
                    _c(
                      "el-select",
                      {
                        staticClass: "item4",
                        attrs: {
                          no: "bookingTerm",
                          filterable: "",
                          clearable: true
                        },
                        model: {
                          value: _vm.job.bookingTerm,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "bookingTerm", $$v)
                          },
                          expression: "job.bookingTerm"
                        }
                      },
                      _vm._l(_vm.SeaExportConstants.BOOKING_TERMS, function(
                        item,
                        index
                      ) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "fieldValidDialog",
            visible: _vm.fieldValidDialog.visible,
            title: _vm.$t("Message.WarmReminder"),
            width: "630px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.fieldValidDialog, "visible", $event)
            }
          }
        },
        [
          _vm._l(_vm.fieldValidDialog.fieldValidResults, function(
            fieldValidResultByBook,
            index
          ) {
            return _c(
              "div",
              { key: index },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_Book") +
                        (fieldValidResultByBook.index + 1)
                    )
                  )
                ]),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: fieldValidResultByBook.data }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "fieldName",
                        label: _vm.$t("CargoMsg.Cargo_FieldName"),
                        width: "180"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "exceptionReason",
                        label: _vm.$t("CargoMsg.Cargo_ErrorCause"),
                        width: "400"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.fieldValidDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              )
            ],
            1
          )
        ],
        2
      ),
      _c("shipping-schedule-dialog", {
        ref: "voyageShowDialog",
        attrs: {
          "append-to-body": "",
          visible: _vm.voyageShowDialog,
          callback: _vm.callbackShippingScheduleHanle
        },
        on: {
          "update:visible": function($event) {
            _vm.voyageShowDialog = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }